const SvgPassword = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.375 9.125V7.375C16.375 4.925 14.45 3 12 3C9.55 3 7.625 4.925 7.625 7.375V9.125C6.1375 9.125 5 10.2625 5 11.75V17.875C5 19.3625 6.1375 20.5 7.625 20.5H16.375C17.8625 20.5 19 19.3625 19 17.875V11.75C19 10.2625 17.8625 9.125 16.375 9.125ZM9.375 7.375C9.375 5.8875 10.5125 4.75 12 4.75C13.4875 4.75 14.625 5.8875 14.625 7.375V9.125H9.375V7.375ZM12.875 16.125C12.875 16.65 12.525 17 12 17C11.475 17 11.125 16.65 11.125 16.125V13.5C11.125 12.975 11.475 12.625 12 12.625C12.525 12.625 12.875 12.975 12.875 13.5V16.125Z"
        fill="#514B4D"
      />
    </svg>
  );
};

export default SvgPassword;
